/* eslint-disable quotes, comma-dangle */

"use strict";

var utils = require("./utils");
var storeHeaderClientLogicUtil = require("./components/storeHeaderClientLogic");
var slickConfigsHeaderBanner = require("./config/slickConfigs").rotatingHeaderBanner;
var menuClientUtil = require("./components/menu");
var jsCssUtils = require("./components/injectDynamicUtils");
var cookie = require("org/util/cookie");
var isAppSession = $("#app-session").val();
var userProfile = require("./header/account").userProfile;
var initTrackOrder = require("./header/trackOrder").initTrackOrder;
var configurePromoBanner = require("./header/banner").configurePromoBanner;

// eslint-disable-next-line valid-jsdoc
/**
 * get cookie by name
 */
function getCookie(name) {
    var value = `; ${document.cookie} ;`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts[1].substr(0, parts[1].indexOf(";")).replace(/"/g, "");
    }
    return null;
}

/**
 * Trigger GTM session data to fetch customer information
 */
function getGTMSessionData() {
    var gtmURL = $("#gtmSessionData").val();
    $.ajax({
        url: gtmURL,
        method: "get",
    }).done(function (data) {
        $("body").append(data);
        var gtmCustomerData = $("#gtmCustomerData").val();
        window.dataLayer.push(JSON.parse(gtmCustomerData));
    });
}

function loadMenu() {
    var menuURL = $('nav').data('menucontent');
    if (menuURL) {
        $.get(menuURL, function (data) {
            $('nav').append(data);
            menuClientUtil();
            storeHeaderCallViaAjax();

            // calling to manage Narvar FAQ Help Center link
            handleNarvarHelpCenterLink();
        });
    }
}

/**
 * get account header
 */
function getMiniCartHeader() {
    if (isAppSession === "true") {
        return;
    }
    if ($("#turnOFFMiniCart").val() === "true") {
        let $miniCartQuantity = $(".minicart .minicart-quantity");
        let qtyCookieVal = getCookie("cartqty");
        if (qtyCookieVal) {
            let qtyCookie = parseInt(qtyCookieVal.split("=")[1], 10);
            if (isNaN(qtyCookie) || qtyCookie <= 0) {
                $miniCartQuantity.addClass("d-none");
            } else {
                $miniCartQuantity.removeClass("d-none");
            }
            $miniCartQuantity.text(qtyCookie);
        }
        return;
    }
    var url = $("#HeaderActionUrl").attr("data-minicartheader");
    var tempCookieVal = getCookie("cartqty");
    if (!tempCookieVal || tempCookieVal === "C=0") {
        tempCookieVal = "y";
    }
    var cookieVal = tempCookieVal;
    if (!sessionStorage.getItem("minicartHeaderData")) {
        $.get(url).done(function (data) {
            sessionStorage.setItem("minicartHeaderData", data);
            sessionStorage.setItem("savedCartqtyCookieVal", cookieVal);
            $(".minicart-header").html(data);
        });
        return;
    }
    if (cookieVal !== sessionStorage.getItem("savedCartqtyCookieVal")) {
        $.get(url).done(function (data) {
            sessionStorage.setItem("minicartHeaderData", data);
            sessionStorage.setItem("savedCartqtyCookieVal", cookieVal);
            $(".minicart-header").html(data);
        });
        return;
    }
    $(".minicart-header").html(sessionStorage.getItem("minicartHeaderData"));
}

/**
 * To Load sdd Availability via Ajax on Desktop and Mobile
 */
function sddAvailabilityCallViaAjax() {
    if (isAppSession === "true") {
        return;
    }
    let $el = utils.mediaBreakpointUp("lg")
        ? $("#sddAvailabilityCallViaAjax")
        : $("#sddAvailabilityCallViaAjaxMobile");
    if (
        $el.length
        && (!sessionStorage.getItem("hideSDD")
            || sessionStorage.getItem("hideSDD") === "false")
    ) {
        let cachedData = sessionStorage.getItem("sddAvailabilityHtml");
        if (cachedData) {
            $el.parent().append(cachedData);
            if (!window.sameDayDeliveryLoaded) {
                if (!utils.mediaBreakpointUp("lg")) {
                    jsCssUtils.injectDynamicJs("#sdd-js-url");
                } else {
                    $(document).on(
                        "click",
                        ".sdd-availability-link",
                        function () {
                            jsCssUtils.injectDynamicJs("#sdd-js-url");
                        }
                    );
                }
            }
            return;
        }
        let url = $el.data("href");
        let sddObject = {
            sameDayDeliveryObject: null,
        };
        if (localStorage.getItem("sameDayDeliveryObject")) {
            sddObject.sameDayDeliveryObject = localStorage.getItem(
                "sameDayDeliveryObject"
            );
        }
        $.ajax({
            url: url,
            method: "POST",
            data: sddObject,
        }).done(function (data) {
            if (data && $(data).filter("#hideSDD").val() === "false") {
                $el.parent().append(data);
                sessionStorage.setItem("sddAvailabilityHtml", data);
                sessionStorage.setItem("hideSDD", false);
            } else if (data && $(data).filter("#hideSDD").val() === "true") {
                sessionStorage.setItem("hideSDD", true);
            }
            if (!window.sameDayDeliveryLoaded) {
                if (!utils.mediaBreakpointUp("lg")) {
                    jsCssUtils.injectDynamicJs("#sdd-js-url");
                } else {
                    $(document).on(
                        "click",
                        ".sdd-availability-link",
                        function () {
                            jsCssUtils.injectDynamicJs("#sdd-js-url");
                        }
                    );
                }
            }
        });
    }
}

/**
 * To Load Store Header via Ajax on Desktop and Mobile
 */
function storeHeaderCallViaAjax() {
    let $el = $(".js-nav-store-ajax");
    let url = $el.data("href");
    $.ajax({
        url: url,
        method: "get"
    }).done(function (data) {
        if (data) {
            $el.parent().append(data);
        }
        storeHeaderClientLogicUtil();
    });
}

// eslint-disable-next-line require-jsdoc
function getAkamaiHeader() {
    var url = $("#akamaiTimestamp").data("timestampurl");
    $.get(url).done(function () {});
}

/**
 * function to rotate header banner messages
 *
 */
function rotatingMsg() {
    var $rotateHeaderBanner = $(
        ".header-banner-content .rotating-msg .html-slot-container"
    );
    var $rotatingHeaderItems = $(
        ".header-banner-content .rotating-msg .html-slot-container .rotating-items"
    );
    var sddAvailability = $(".header-banner-content").find(
        ".sdd-availability"
    ).length;
    var rotatingTimer = $rotateHeaderBanner.find("#rotatingTimer").val();
    slickConfigsHeaderBanner.autoplaySpeed = rotatingTimer
        ? parseInt(rotatingTimer, 10)
        : slickConfigsHeaderBanner.autoplaySpeed;
    $rotateHeaderBanner.find("#rotatingTimer").remove();
    if (sddAvailability) {
        $rotateHeaderBanner.append(
            $(
                '<div class="rotating-items sdd-msg sdd-availability-banner"></div>'
            )
        );
        var $sddMsgPlaceholder = $(
            ".header-banner-content .rotating-msg .rotating-items.sdd-msg"
        );
        var $sddActualMsg = $(
            ".header-banner-content .sdd-availability .sdd-availability-banner"
        ).html();
        $sddMsgPlaceholder.html($sddActualMsg);
        $rotateHeaderBanner.slick(slickConfigsHeaderBanner);
        $("#sddAvailabilityCallViaAjax")
            .nextAll(".sdd-availability")
            .find(".sdd-availability-banner")
            .remove();
        $rotatingHeaderItems.css("visibility", "visible");
    } else {
        $rotateHeaderBanner.slick(slickConfigsHeaderBanner);
        $rotatingHeaderItems.css("visibility", "visible");
    }
}

/**
 * function to inject dynamic css for footer on page scroll
 *
 */
function getFooterCss() {
    // Loading footer css with intersection observer
    let $el = $("footer");
    if ($el.length && "IntersectionObserver" in window) {
        const config = {
            rootMargin: "300px 0px 0px 0px",
            threshold: 0,
        };
        let observer = new IntersectionObserver((entry) => {
            if (entry[0].isIntersecting) {
                $("body").trigger("product:beforeFooterLoads");
            }
        }, config);
        observer.observe($el[0]);
    }

    // Loading footer css on scroll
    $(window).scroll(function () {
        $("body").trigger("product:beforeFooterLoads");
    });
}

/**
 * site wide banner analytics changes
 */
function siteWideBannerAnalytics() {
    $(".site-wide-banner").each(function () {
        var arryData = [];
        $(this).attr("data-position", 1);
        arryData.push({
            id: $(this).data("ci-tracking"),
            name: $(this).data("campaign-name"),
            creative: $(this).data("creative-name"),
            position: $(this).data("position"),
        });

        let componentType = "sitewidebanner";
        if ($(this).data("component-name")) {
            componentType = $(this).data("component-name");
        }

        let obj = {
            event: "Banner Impression",
            componentType: componentType,
            ecommerce: {
                promoView: {
                    promotions: arryData,
                },
            },
        };

        window.dataLayer.push(obj);

        var isCategorySearch = $("#isCategorySearch");
        var searchQueryData = {};
        if (isCategorySearch.length) {
            var isCategorySearchResult = isCategorySearch.val() === "true"
                && isCategorySearch.attr("data-is-search-param") === "false";
            searchQueryData = {
                queryData: "",
                suggestResult: "",
                eventLabel: "",
                experienceType: "",
            };

            if (!isCategorySearchResult) {
                if (sessionStorage.getItem("searchQueryData")) {
                    searchQueryData = JSON.parse(
                        sessionStorage.getItem("searchQueryData")
                    );
                }
            }
        }
        var customDimension = {
            gtmContainerId: $("#googleTagManagerIdNew").val(),
            searchInput: searchQueryData.queryData,
            productSKU: searchQueryData.productSKU,
            searchAutocompleteCategory:
                searchQueryData.searchAutocompleteCategory,
            searchAutocompleteValue: searchQueryData.suggestResult,
            cartValue: searchQueryData.cartValue,
            componentType: componentType,
            experienceType: searchQueryData.experienceType,
            filterType: searchQueryData.filterType,
            filterValue: searchQueryData.filterValue,
            persistentSignIn: searchQueryData.persistentSignIn,
            storeId: searchQueryData.storeId,
            memberTier: searchQueryData.memberTier,
            authenticationState: searchQueryData.authenticationState,
            paymentType: searchQueryData.paymentType,
            reviewsRating: searchQueryData.reviewsRating,
            reviewsNumber: searchQueryData.reviewsNumber,
        };
        var customMetric = {
            orderDiscount: searchQueryData.orderDiscount,
            eventValue: searchQueryData.eventValue,
        };
        var analyticsObj = {
            event: "analyticsEvent",
            eventCategory: "ecommerce",
            eventAction: "promotion viewed",
            eventLabel: $(this).data("creative-name") || "sitewidebanner",
            ecommerce: {
                promoView: {
                    promotions: arryData,
                },
            },
            customDimensions: customDimension,
            customMetrics: customMetric,
        };
        window.dataLayer.push(analyticsObj);
    });

    $(document).on("click", ".site-wide-banner a", function () {
        let $siteWideBanner = $(this).closest(".site-wide-banner");
        let campaignID = $siteWideBanner.data("ci-tracking");
        let campaignName = $siteWideBanner.data("campaign-name");
        let headingdata = $siteWideBanner.data("creative-name");
        let position = $siteWideBanner.data("position");
        let componentType = "sitewidebanner";
        var isCategorySearch = $("#isCategorySearch");
        var searchQueryData = {};
        if (isCategorySearch.length) {
            var isCategorySearchResult = isCategorySearch.val() === "true"
                && isCategorySearch.attr("data-is-search-param") === "false";
            searchQueryData = {
                queryData: "",
                suggestResult: "",
                eventLabel: "",
                experienceType: "",
            };

            if (!isCategorySearchResult) {
                if (sessionStorage.getItem("searchQueryData")) {
                    searchQueryData = JSON.parse(
                        sessionStorage.getItem("searchQueryData")
                    );
                }
            }
        }

        if ($siteWideBanner.data("component-name")) {
            componentType = $siteWideBanner.data("component-name");
        }
        $("body").trigger("promotion:bannerPromotionClicked", {
            campaignID: campaignID,
            campaignName: campaignName,
            heading: headingdata,
            position: position,
            componentType: componentType,
            promoPosition: position,
            searchInput: searchQueryData.queryData,
            searchAutocompleteValue: searchQueryData.suggestResult,
            experienceType: searchQueryData.experienceType,
        });
    });
}

/**
 * function to manage Narvar Help Center link FAQ
 * for New FAQ it should not redirect to Narvar Help Center
 */
function handleNarvarHelpCenterLink() {
    var $faqRedesign = $(".faq-redesign");
    var isFaqRedesignRequired = $("#isFaqRedesign").val();
    if (isFaqRedesignRequired === "true") {
        $faqRedesign.attr("href", $("#isFaqRedesign").data("href"));
        $faqRedesign.removeAttr("target");
    } else {
        $faqRedesign.attr("href", "https://care.gamestop.com/");
        $faqRedesign.attr("target", "_blank");
    }
}

module.exports = function () {
    var isDesktop = function () {
        return utils.mediaBreakpointUp("lg");
    };

    // Trigger GTM session data to fetch customer information
    if ($("#bypassAkamai").val() === "true") {
        getGTMSessionData();
    }

    setTimeout(function () {
        rotatingMsg();
    }, 1000);

    $(".minicart").on("minicartheader:update", function () {
        getMiniCartHeader();
    });

    var $headerBannerSlick = $(
        ".header-banner-content .rotating-msg .html-slot-container"
    );
    $("body").on(
        "click",
        ".header-banner-content .sdd-availability-banner button",
        function () {
            $headerBannerSlick.slick("slickPause");
        }
    );

    $("body").on("hide.bs.modal", "#samDayDeliveryModal", function () {
        $headerBannerSlick.slick("slickPlay");
    });

    siteWideBannerAnalytics();
};

/**
 * Gets LinkShare Affiliate ID cookie
 * cookie value
 */
function saveLinkShare() {
    var LINKSHARE_COOKIE_NAMES = {
        SITE_ID: "linkshareSiteID",
        AFFILIATE_ID: "linkshareAffiliateID",
    };
    var linkShareCookieMaxAge = document.querySelector(
        "#linkShareCookieMaxAge"
    );
    var cookieMaxAge = linkShareCookieMaxAge
        ? Number(linkShareCookieMaxAge.value)
        : 86400;
    var currentUrl = window.location.href;
    var siteUrl = utils.getQueryStringParams(currentUrl);
    var affIDVal = null;
    var sourceIDVal = null;

    if (siteUrl && siteUrl.affID) {
        affIDVal = siteUrl.affID;
        cookie.set(LINKSHARE_COOKIE_NAMES.AFFILIATE_ID, affIDVal, {
            expires: cookieMaxAge,
            secure: true,
        });
    }

    if (siteUrl && siteUrl.sourceID) {
        sourceIDVal = siteUrl.sourceID;
        cookie.set(LINKSHARE_COOKIE_NAMES.SITE_ID, sourceIDVal, {
            expires: cookieMaxAge,
            secure: true,
        });
    }
}

$(document).ready(function () {
    configurePromoBanner();
    userProfile();
    initTrackOrder();
    loadMenu();
    getMiniCartHeader();
    sddAvailabilityCallViaAjax();
    getAkamaiHeader();
    getFooterCss();

    // calling to manage Narvar FAQ Help Center link
    handleNarvarHelpCenterLink();

    saveLinkShare();
    var $contactUs = $(".contactUs");
    var isContactUsRequired = $("#footerContactUsVal").val();
    if ($contactUs.length && isContactUsRequired === "false") {
        $contactUs.remove();
    }
});
